import { assignment } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';

export function countUnprocessedAssignments({
  url: { service: baseURL },
  token,
}: IAPI) {
  return async function countUnprocessedAssignments(
    country: string
  ): Promise<assignment.UnprocessedCount> {
    const url = new URL(
      `/assignment/application/unprocessed/${country}/count`,
      baseURL
    );
    try {
      const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return await response.json();
    } catch {
      throw new Error('Failed to count unprocessed assignments');
    }
  };
}
